if (document.querySelector('#resource-entries')) {
  var app = new Vue({
    name: 'share',
    el: '#resource-entries',
    props: {
      from: String,
      name: String
    },
    data: {
      dialog: {
        visible: false,
        title: 'Sharing',
        url: ''
      },
      email: '',
      phone: ''
    },
    methods: {
      toggleDialog(resource, url) {
        this.dialog = {
          visible: true,
          title: resource.title,
          url
        };
      },
      closeDialog() {
        this.dialog = {
          visible: false
        };
        this.phone = '';
        this.email = '';
      },
      sendEmail(from, fromEmail) {
        let data = {
          subject: this.dialog.title,
          url: this.dialog.url,
          email: this.email,
          from,
          fromEmail
        };

        axios.post('/actions/ariq-module/resource/mail', data).then((res) => {
          console.log(res);
          this.closeDialog();
        })
        .catch((err) => {
          console.log(err);
        });
      },
      sendText() {
        let data = {
          subject: this.dialog.title,
          url: this.dialog.url,
          phone: this.phone.replaceAll('-', '')
        };

        axios.post('/actions/ariq-module/resource/text', data).then((res) => {
          console.log(res);
          this.closeDialog();
        })
        .catch((err) => {
          console.log(err);
        });
      }
    },
    computed: {
      title() {
        return `Sharing: ${this.dialog.title}`;
      }
    }
  });
}